import { render } from "./VetReviewPreview.vue?vue&type=template&id=07d5dfba&scoped=true&ts=true"
import script from "./VetReviewPreview.vue?vue&type=script&lang=ts"
export * from "./VetReviewPreview.vue?vue&type=script&lang=ts"

import "./VetReviewPreview.vue?vue&type=style&index=0&id=07d5dfba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d5dfba"]])

export default __exports__